// React
import { useEffect, useState } from "react";
// Recoil
import { useRecoilState } from "recoil";
import { cartState } from "../../atom/menu";
// Assets
import { optionListData } from "../../assets/optionListData";
import { optionTypeList } from "../../assets/optionTypeList";
import { menuListType, OptionListType, OptionType } from "../../assets/Type";
import ControllerOrder from "../../components/menu/common/ControllerOrder";

type PopupOptionType = {
  data: menuListType;
  action: () => void;
};
type optionType = {
  value: number;
  label: string;
};

function PopupOption(props: PopupOptionType) {
  // 옵션 선택 화면

  // Recoil State
  const [cartData, setCartData] = useRecoilState(cartState);

  // useState
  const viewOption = optionListData.filter(
    (category) =>
      props.data.option.findIndex((val) => val === category.category) > -1
  );
  const viewOptionCategory = optionTypeList.filter(
    (v) => props.data.option.findIndex((d) => d === v.value) > -1
  );
  const [selectedOption, setSelectedOption] = useState<OptionType[] | null>(
    null
  );
  const [isTooltip, setIsTooltip] = useState<boolean>(false);
  const [isErrorType1, setIsErrorType1] = useState<boolean>(false);
  const [isErrorType2, setIsErrorType2] = useState<boolean>(false);
  const [optionType, setOptionType] = useState<number>(0);

  useEffect(() => {
    if (props.data.option) {
      setOptionType(props.data.option[0]);
    }
  }, [props.data]);
  useEffect(() => {
    // 사이드 필수 옵션 1개만 선택 가능
    if (
      (calcTotalOptionEASalad(optionType) && optionType === 0) ||
      optionType === 5
    ) {
      if (calcTotalOptionEASalad(optionType) < 1) {
        setOptionType(0);
        setIsErrorType1(false);
        setIsErrorType2(true);
      } else if (calcTotalOptionEASalad(optionType) > 1) {
        setOptionType(0);
        setIsErrorType1(true);
        setIsErrorType2(false);
      } else {
        setIsErrorType1(false);
        setIsErrorType2(false);
      }
    }
  }, [selectedOption]);

  const optionControl = (option: OptionListType) => {
    if (selectedOption) {
      const prev = [...selectedOption!];
      if (
        prev.findIndex((v) => {
          return v.name === option.name;
        }) > -1
      ) {
        prev.splice(
          prev.findIndex((v) => {
            return v.name === option.name;
          }),
          1
        );
        setSelectedOption([...prev]);
      } else {
        prev.push({
          type: option.category,
          name: option.name,
          ea: 1,
          price: option.price,
        });
        setSelectedOption([...prev]);
      }
    } else {
      setSelectedOption([
        {
          type: option.category,
          name: option.name,
          ea: 1,
          price: option.price,
        },
      ]);
      setIsTooltip(true);
    }
  };
  const addOption = (optionData: OptionType) => {
    if (selectedOption) {
      const prev = [...selectedOption!];
      if (
        prev.find((option) => {
          return option.name === optionData.name;
        })
      ) {
        prev.splice(
          selectedOption.findIndex((option) => {
            return option.name === optionData.name;
          }),
          1,
          {
            ...optionData,
            ea: optionData.ea + 1,
          }
        );
        setSelectedOption([...prev]);
      }
    }
  };
  const minusOption = (optionData: OptionType) => {
    if (selectedOption) {
      const prev = [...selectedOption!];
      if (
        prev.find((option) => {
          return option.name === optionData.name;
        })
      ) {
        if (
          prev.find((option) => {
            return option.name === optionData.name;
          })?.ea === 1
        ) {
          prev.splice(
            selectedOption.findIndex((option) => {
              return option.name === optionData.name;
            }),
            1
          );
        } else {
          prev.splice(
            selectedOption.findIndex((option) => {
              return option.name === optionData.name;
            }),
            1,
            {
              ...optionData,
              ea: optionData.ea - 1,
            }
          );
        }
        setSelectedOption([...prev]);
      }
    }
  };

  function calcTotalOptionEA() {
    // 옵션총개수 계산
    if (selectedOption) {
      let option = 0 as number;
      selectedOption.reduce((acc, cur) => {
        option = acc + cur.ea;
        return option;
      }, option);
      return option;
    } else {
      return 0;
    }
  }
  function calcTotalOptionEASalad(type: number) {
    const check = selectedOption?.filter((options) => {
      return options.type === type;
    });
    // 옵션총개수 계산
    if (check) {
      let option = 0 as number;
      check.reduce((acc, cur) => {
        option = acc + cur.ea;
        return option;
      }, option);
      return option;
    } else {
      return 0;
    }
  }
  const nextPage = () => {
    if (optionType === 0 || optionType === 5) {
      // 필수 옵션인 경우 선택된 필수 옵션 체크
      if (calcTotalOptionEASalad(optionType) < 1) {
        setIsErrorType1(false);
        setIsErrorType2(true);
      } else if (calcTotalOptionEASalad(optionType) > 1) {
        setIsErrorType1(true);
        setIsErrorType2(false);
      } else {
        // 필수 옵션 만큼 선택 되었을 경우
        if (
          viewOptionCategory.length - 1 ===
          viewOptionCategory.findIndex((v) => v.value === optionType)
        ) {
          // 마지막 카테고리인 경우 카트에 담기
          if (cartData) {
            const prevCartData = [...cartData];
            if (prevCartData) {
              prevCartData.push({
                name: props.data.name,
                price: props.data.salePrice,
                ea: 1,
                option: selectedOption,
              });
              setCartData(prevCartData);
            }
            props.action();
          }
        } else {
          setIsErrorType1(false);
          setIsErrorType2(false);
          const pre = viewOptionCategory.findIndex(
            (v) => v.value === optionType
          );
          setOptionType(viewOptionCategory[pre + 1].value);
        }
      }
    } else if (
      viewOptionCategory.length - 1 ===
      viewOptionCategory.findIndex((v) => v.value === optionType)
    ) {
      // 마지막 카테고리인 경우 카트에 담기
      if (cartData) {
        const prevCartData = [...cartData];
        if (prevCartData) {
          prevCartData.push({
            name: props.data.name,
            price: props.data.salePrice,
            ea: 1,
            option: selectedOption,
          });
          setCartData(prevCartData);
        }
        props.action();
      }
    } else {
      const pre = viewOptionCategory.findIndex((v) => v.value === optionType);
      setOptionType(viewOptionCategory[pre + 1].value);
    }
  };
  const prevPage = () => {
    setOptionType(optionType - 1);
  };

  return (
    <div className='menu-popup-bg'>
      <div className='menu-popup-wrap'>
        <div className='menu-intro-wrap' style={{ gap: 32 }}>
          <div
            className='TO-title-2 text-color-gray-3'
            style={{ textAlign: "center" }}
          >
            {optionType === 0
              ? "필수 옵션을 추가해주세요"
              : "선택 옵션을 추가해주세요"}
          </div>
          <div className='flex row'>
            {/* 메뉴 설명 부분 */}
            <div className='option-menu-wrap'>
              <div className='scroll'>
                <div className='img-center-crop'>
                  <img
                    src={`/assets/images/menuimg/${props.data.img}`}
                    alt={`${props.data.name}`}
                  />
                </div>
                <div className='option-menu-content-box'>
                  <div className='flex col h-auto' style={{ gap: 4 }}>
                    <div className='wrap-b'>
                      {props.data.bedg.map((v) => {
                        return v === "맵기1" ? (
                          <span className='bedg TO-option-3'>
                            <img
                              src={"/assets/images/menu/spicy.png"}
                              alt='spicy icon'
                            />
                          </span>
                        ) : v === "맵기2" ? (
                          <span className='bedg TO-option-3'>
                            <img
                              src={"/assets/images/menu/spicy.png"}
                              alt='spicy icon'
                            />
                            <img
                              src={"/assets/images/menu/spicy.png"}
                              alt='spicy icon'
                            />
                          </span>
                        ) : v === "맵기3" ? (
                          <span className='bedg TO-option-3'>
                            <img
                              src={"/assets/images/menu/spicy.png"}
                              alt='spicy icon'
                            />
                            <img
                              src={"/assets/images/menu/spicy.png"}
                              alt='spicy icon'
                            />
                            <img
                              src={"/assets/images/menu/spicy.png"}
                              alt='spicy icon'
                            />
                          </span>
                        ) : (
                          <span className='bedg TO-option-3'>{v}</span>
                        );
                      })}
                    </div>
                    <div className='TO-button-2 w-100'>{props.data.name}</div>
                    <div className='TO-body-3 text-color-gray-6'>
                      {props.data.isDescription}
                    </div>
                  </div>
                </div>
              </div>
              <div className='type-3-price relative'>
                <div className='botton-bg-gradation'></div>
                {props.data.isDiscount && (
                  <span className='TO-price-3-strike text-color-gray-6'>
                    {props.data.salePrice.toLocaleString()}
                  </span>
                )}
                <span className='TO-price-2 text-color-gray-3'>
                  {props.data.price.toLocaleString()} 원
                </span>
              </div>
            </div>
            {/* 카테고리 부분 */}
            <div
              className='flex col justify-content-between'
              style={{ gap: 16, marginLeft: 16 }}
            >
              <div className='flex col'>
                <div
                  className='flex row h-auto scroll-w'
                  style={{ gap: 8, marginBottom: 16 }}
                >
                  {viewOptionCategory.map((v, i) => {
                    return optionType === v.value ? (
                      <div className='option-type-box-active TO-button-2'>
                        <div className='round TO-option-2'>{i + 1}</div>
                        {v.label} 선택
                      </div>
                    ) : (
                      <div className='option-type-box TO-button-2'>
                        <div className='round TO-option-2'>{i + 1}</div>
                        {v.label} 선택
                      </div>
                    );
                  })}
                  {/* {optionTypeList.map((v, i) => {
                    return optionType === v.value ? (
                      <div className='option-type-box-active TO-button-2'>
                        <div className='round TO-option-2'>{i + 1}</div>
                        {v.label} 선택
                      </div>
                    ) : (
                      <div className='option-type-box TO-button-2'>
                        <div className='round TO-option-2'>{i + 1}</div>
                        {v.label} 선택
                      </div>
                    );
                  })} */}
                </div>
                {/* 카테고리 리스트 부분 */}
                <div
                  className='flex col scroll'
                  style={{ gap: 8, height: 408, paddingBottom: 30 }}
                >
                  {viewOption.map((v) => {
                    return (
                      v.category === optionType && (
                        <>
                          {v.isSale ? (
                            <div
                              className='option-list-box'
                              onClick={() => {
                                optionControl(v);
                              }}
                            >
                              <div className='flex row align-items-center w-100'>
                                {selectedOption &&
                                selectedOption!.findIndex((V) => {
                                  return V.name === v.name;
                                }) > -1 ? (
                                  <div className='option-check-box-selected'>
                                    <img
                                      src={
                                        "/assets/images/menu/check_icon_white.svg"
                                      }
                                      alt='check icon'
                                    />
                                  </div>
                                ) : (
                                  <div className='option-check-box-empty'></div>
                                )}
                                <div
                                  className='TO-option-1 text-elipsis-2'
                                  style={{ maxWidth: 478 }}
                                >
                                  {v.name}
                                </div>
                              </div>
                              {selectedOption &&
                              selectedOption!.findIndex((V) => {
                                return V.name === v.name;
                              }) > -1 ? (
                                <ControllerOrder
                                  value={
                                    selectedOption.find(
                                      (val) => val.name === v.name
                                    )!.ea
                                  }
                                  option={selectedOption.find(
                                    (val) => val.name === v.name
                                  )}
                                  actionAdd={addOption}
                                  actionMinus={minusOption}
                                />
                              ) : (
                                <div></div>
                              )}

                              {v.price > 0 ? (
                                <div
                                  className='TO-price-3'
                                  style={{ minWidth: 128, marginLeft: 20 }}
                                >
                                  + {v.price.toLocaleString()}원
                                </div>
                              ) : (
                                <div
                                  style={{
                                    width: 120,
                                    minWidth: 128,
                                    maxWidth: 128,
                                    height: 20,
                                    marginLeft: 20,
                                  }}
                                ></div>
                              )}
                            </div>
                          ) : (
                            <div className='option-list-box soldout-option'>
                              <div className='flex row align-items-center w-auto'>
                                <div
                                  className='option-check-box-empty'
                                  style={{ borderColor: "#DADADA" }}
                                ></div>
                                <div
                                  className='TO-option-1 text-elipsis-2 text-color-gray-6'
                                  style={{
                                    maxWidth: 478,
                                    display: "inline-flex",
                                  }}
                                >
                                  {v.name}
                                </div>
                                <span
                                  className='bedg TO-option-3'
                                  style={{ marginLeft: 16 }}
                                >
                                  품절
                                </span>
                              </div>
                              {v.price > 0 && (
                                <div className='TO-price-3 text-color-gray-6'>
                                  + {v.price.toLocaleString()}원
                                </div>
                              )}
                            </div>
                          )}
                        </>
                      )
                    );
                  })}
                </div>
              </div>
              <div
                className='menu-popup-button relative'
                style={{
                  padding: "16px 0 0 0",
                  justifyContent: "space-between",
                }}
              >
                <div
                  className='botton-bg-gradation'
                  style={{ top: "-63px", width: "101%" }}
                ></div>
                <div
                  className='basic-btn white TO-button-1 pointer'
                  style={{ maxWidth: 208 }}
                  onClick={() => {
                    props.action();
                  }}
                >
                  닫기
                </div>
                {optionType !== 0 &&
                  viewOptionCategory.length > optionType - 1 && (
                    <div
                      className='basic-btn white TO-button-1 pointer'
                      style={{ maxWidth: 208 }}
                      onClick={() => {
                        prevPage();
                      }}
                    >
                      이전
                    </div>
                  )}

                {isTooltip && (
                  <div
                    className='tooltip-box TO-button-2'
                    style={{
                      width: 220,
                      left: 740,
                      top: "-60px",
                      backgroundColor: "#F93822",
                    }}
                  >
                    현재 {calcTotalOptionEA()}개 선택
                    <img
                      src={"/assets/images/menu/close_gray.svg"}
                      alt='close icon'
                      onClick={() => {
                        setIsTooltip(false);
                      }}
                    />
                    <div
                      className='triangle'
                      style={{ left: "calc(50% - 75px)" }}
                    ></div>
                  </div>
                )}
                <div
                  className='basic-btn TO-button-1 pointer relative'
                  style={{ maxWidth: "100%" }}
                  onClick={() => {
                    nextPage();
                  }}
                >
                  다음
                  <img
                    src={"/assets/images/menu/arrow_left_white.svg"}
                    alt='arrow right icon'
                    style={{
                      transform: "rotate(180deg)",
                      marginTop: 4,
                      marginLeft: 4,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {isErrorType1 && (
          <div className='error-box TO-title-2'>
            1가지만 선택 가능합니다. 다른 옵션을 해제하고 선택해주세요
          </div>
        )}
        {isErrorType2 && (
          <div className='error-box TO-title-2'>
            필수 옵션을 1가지 선택해 주세요
          </div>
        )}
      </div>
    </div>
  );
}
export default PopupOption;
